<template>
  <div class="row mb-5">
    <div class="col-12">
      <h3 class="mb-4">Create New Voucher Codes</h3>

      <form
        @submit.prevent="onSubmit"
      >
        <div class="form-row">
          <FormSelect
            v-model="type"
            class="col-3"
            id="type"
            label="Voucher Code Types"
            :options="[{
              label: 'Unlock Referral Code',
              value: 'unlockReferralCode',
            }]"
            :error="getFieldError('type')"
          />

          <FormInput
            v-model="quantity"
            class="col-3"
            type="number"
            :min="1"
            :max="20"
            id="quantity"
            label="Quantity of Codes"
            :error="getFieldError('quantity')"
          />

          <FormInput
            v-model="expiresAt"
            class="col-3"
            type="date"
            :min="tomorrow"
            id="expiresAt"
            label="Expiration Date"
            :error="getFieldError('expiresAt')"
          />

          <div
            class="col-auto"
          >
            <label class="d-block">&nbsp;</label>

            <FormButton
              :isProcessing="isProcessing"
            >
              Create
            </FormButton>
          </div>
        </div>

        <FormError
          :error="getRequestError()"
        />
      </form>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import AdminAPI from '@/api/AdminAPI'

  import RequestMixin from '@/mixins/RequestMixin'

  import FormButton from '@/components/FormButton'
  import FormError from '@/components/FormError'
  import FormInput from '@/components/FormInput'
  import FormSelect from '@/components/FormSelect'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      FormButton,
      FormError,
      FormInput,
      FormSelect,
    },

    data() {
      return {
        type: 'unlockReferralCode',
        quantity: 5,
        expiresAt: moment().add(1, 'month').format('YYYY-MM-DD'),
      }
    },

    computed: {
      tomorrow() {
        return moment().add(1, 'days').format('YYYY-MM-DD')
      },
    },

    methods: {
      async createVouchers() {
        await AdminAPI.createVoucherCodes({
          type: this.type,
          quantity: this.quantity,
          expiresAt: moment(this.expiresAt, 'YYYY-MM-DD').format('YYYY-MM-DD'),
        })

        this.$emit('voucherCodesCreated')
      },

      async onSubmit() {
        this.handleRequest(this.createVouchers)
      },
    },
  }
</script>

<style>

</style>
